module.exports = __webpack_public_path__ + "img/20191205171231093.b1d7f50a.jpg";